let apiUrl =
  process.env.REACT_APP_API || "https://endpoint.charlessmithassociates.com/";
if (
  window.location.href.includes("jcsoftwaresolution") ||
  window.location.href.includes("localhost") ||
  window.location.href.includes("74.208.13.142")
) {
  //  apiUrl = "https://endpoint.charlessmithassociates.com/";
  apiUrl = "https://iknowapi.jcsoftwaresolution.in/";
}
const environment = {
  api: apiUrl,
  chatbot_api: apiUrl,
  user_role_id: "6996bdbee63505b3e36d1567",
  DB_NAME: "ShopCartDB",
  STORE_NAME: "cart",
  DB_VERSION: 1,
};

export default environment;
